export var NotificationDeliveryWindow = /*#__PURE__*/function (NotificationDeliveryWindow) {
  NotificationDeliveryWindow["STANDARD"] = "STANDARD";
  NotificationDeliveryWindow["TIMEZONE"] = "TIMEZONE";
  NotificationDeliveryWindow["INFORMED"] = "INFORMED";
  NotificationDeliveryWindow["HOLD_OUT"] = "HOLD_OUT";
  return NotificationDeliveryWindow;
}({});